import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  info: null,
  currentLanguage: null,
  modalLoaded: false,
};

export const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setInfoData(state, { payload: userData }) {
      state.info = userData;
    },
    setModalStatus(state) {
      state.modalLoaded = true;
    },
  },
});

export const { setInfoData, setModalStatus } = authSlice.actions;

export default authSlice.reducer;
